import { type MetaFunction } from "react-router"
import {
	TypographyH1,
	TypographyH2,
	TypographyH3,
	TypographyP,
} from "#app/components/ui/typography.tsx"
import { APP_NAME } from "#app/utils/constants"
import { generateMeta } from "#app/utils/meta"

export const meta: MetaFunction = () => {
	return generateMeta({
		title: `Términos y Condiciones - ${APP_NAME}`,
		description:
			"Términos y condiciones de compra de Greta's Patchwork. Información sobre políticas de envío, devoluciones y condiciones generales.",
		canonical: "/tos",
	})
}

export default function TermsOfServiceRoute() {
	return (
		<main className="container h-full py-12">
			<div className="mx-auto max-w-3xl">
				<TypographyH1>Términos y Condiciones</TypographyH1>

				<TypographyP className="mt-6">
					Bienvenido a {APP_NAME}. Al acceder y utilizar nuestro sitio web,
					aceptas los siguientes términos y condiciones. Si no estás de acuerdo
					con alguno de estos términos, por favor no utilices nuestro sitio.
				</TypographyP>

				<TypographyH2 className="mt-8">
					1. Aceptación de los Términos
				</TypographyH2>
				<TypographyP>
					Al acceder a este sitio web, aceptas cumplir con estos términos y
					condiciones, así como con todas las leyes y regulaciones aplicables.
					Si no aceptas alguno de estos términos, tienes prohibido usar o
					acceder a este sitio.
				</TypographyP>

				<TypographyH2 className="mt-8">2. Uso del Sitio Web</TypographyH2>
				<TypographyP>
					El contenido de este sitio web es para tu información general y uso
					personal. Queda prohibido:
				</TypographyP>
				<ul className="my-6 ml-6 list-disc space-y-2">
					<li>Usar el sitio de manera que cause daño o perjuicio</li>
					<li>Realizar actividades ilegales o fraudulentas</li>
					<li>Copiar, reproducir o distribuir el contenido sin autorización</li>
					<li>Utilizar robots o scripts automatizados para acceder al sitio</li>
				</ul>

				<TypographyH2 className="mt-8">3. Cuentas de Usuario</TypographyH2>
				<TypographyP>
					Para realizar compras en nuestro sitio, puedes registrarte creando una
					cuenta. Eres responsable de:
				</TypographyP>
				<ul className="my-6 ml-6 list-disc space-y-2">
					<li>Mantener la confidencialidad de tu contraseña</li>
					<li>Todas las actividades que ocurran bajo tu cuenta</li>
					<li>Notificarnos inmediatamente sobre cualquier uso no autorizado</li>
				</ul>

				<TypographyH2 className="mt-8">4. Proceso de Compra</TypographyH2>
				<TypographyH3 className="mt-6">4.1 Pedidos</TypographyH3>
				<TypographyP>
					Al realizar un pedido, estás ofreciendo comprar productos sujetos a
					disponibilidad. Confirmaremos tu pedido mediante un email de
					confirmación.
				</TypographyP>

				<TypographyH3 className="mt-6">4.2 Precios</TypographyH3>
				<TypographyP>
					Todos los precios están indicados en euros (€) e incluyen el IVA
					correspondiente. Nos reservamos el derecho de modificar precios en
					cualquier momento. Los cambios no afectarán pedidos ya confirmados.
				</TypographyP>

				<TypographyH3 className="mt-6">4.3 Formas de Pago</TypographyH3>
				<TypographyP>
					Aceptamos las siguientes formas de pago: tarjetas de crédito/débito
					(Visa, Mastercard, American Express) y otros métodos indicados en el
					checkout. Todas las transacciones son seguras y cifradas.
				</TypographyP>

				<TypographyH2 className="mt-8">5. Envíos y Entregas</TypographyH2>
				<TypographyP>
					Realizamos envíos únicamente a España (Península, Baleares, Canarias,
					Ceuta y Melilla) y otros países europeos. No se realizan envíos fuera
					de Europa. Los gastos de envío se calculan en función del destino y se
					mostrarán antes de finalizar el pedido.
				</TypographyP>
				<TypographyP className="mt-4">
					Los plazos de entrega aproximados son:
				</TypographyP>
				<ul className="my-6 ml-6 list-disc space-y-2">
					<li>Península: 2-5 días laborables</li>
					<li>Baleares: 5-7 días laborables</li>
					<li>Canarias, Ceuta y Melilla: 7-14 días laborables</li>
					<li>Otros países europeos: 7-14 días laborables</li>
				</ul>

				<TypographyH2 className="mt-8">
					6. Política de Devoluciones
				</TypographyH2>
				<TypographyP>
					Consulta nuestra{" "}
					<a href="/return-policy" className="underline hover:text-primary">
						Política de Devoluciones
					</a>{" "}
					para información detallada sobre cómo devolver productos, plazos y
					condiciones aplicables.
				</TypographyP>

				<TypographyH2 className="mt-8">7. Propiedad Intelectual</TypographyH2>
				<TypographyP>
					Todo el contenido de este sitio (diseños, textos, imágenes, logotipos,
					etc.) está protegido por derechos de autor y pertenece a {APP_NAME} o
					a sus respectivos propietarios. Queda prohibido el uso sin
					autorización expresa.
				</TypographyP>

				<TypographyH2 className="mt-8">
					8. Limitación de Responsabilidad
				</TypographyH2>
				<TypographyP>{APP_NAME} no será responsable de:</TypographyP>
				<ul className="my-6 ml-6 list-disc space-y-2">
					<li>Pérdidas o daños indirectos</li>
					<li>
						Interrupciones del servicio por causas ajenas a nuestra voluntad
					</li>
					<li>Errores en la información proporcionada por terceros</li>
				</ul>

				<TypographyH2 className="mt-8">9. Modificaciones</TypographyH2>
				<TypographyP>
					Nos reservamos el derecho de modificar estos términos en cualquier
					momento. Los cambios entrarán en vigor inmediatamente al publicarse en
					el sitio. Te recomendamos revisar esta página periódicamente.
				</TypographyP>

				<TypographyH2 className="mt-8">10. Ley Aplicable</TypographyH2>
				<TypographyP>
					Estos términos se rigen por las leyes de España. Cualquier disputa
					será resuelta por los tribunales competentes de la provincia donde se
					encuentra nuestra sede.
				</TypographyP>

				<TypographyH2 className="mt-8">11. Contacto</TypographyH2>
				<TypographyP>
					Para cualquier pregunta sobre estos términos, contacta con nosotros:
				</TypographyP>
				<TypographyP className="mt-4 font-semibold">
					info@gretaspatchwork.com
				</TypographyP>

				<TypographyP className="mt-8 text-sm text-muted-foreground">
					Última actualización: Febrero 2026
				</TypographyP>
			</div>
		</main>
	)
}
